(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["admin/main/includes/_products_search_results.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "products")) > 0) {
output += "\n    <thead class=\"comet-data-table__head\">\n        <tr class=\"comet-data-table__row\">\n            <th class=\"comet-data-table__header\">\n                Select\n            </th>\n            <th class=\"comet-data-table__header\">\n                Products\n            </th>\n        </tr>\n    </thead>\n\n    <tbody>\n        ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "products");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n            <tr class=\"comet-data-table__row\">\n                <td class=\"comet-data-table__cell\" data-label=\"Select\">\n                    <label class=\"comet-form__checkbox\" for=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\">\n                        <input id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\" type=\"checkbox\" class=\"comet-form__checkbox-input\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\" />\n                        <span class=\"comet-form__checkbox-visual\" aria-focusable=\"false\">\n                            <svg class=\"comet-form__checkbox-checked-icon\" aria-hidden=\"true\" focusable=\"false\">\n                                <use xlink:href=\"";
output += runtime.suppressValue((lineno = 20, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["comet/2.x/comet.svg#check"])), env.opts.autoescape);
output += "\"></use>\n                            </svg>\n                        </span>\n                    </label>\n                </td>\n                <td class=\"comet-data-table__cell\" data-label=\"Product Name\">\n                    ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"name"), env.opts.autoescape);
output += "\n                </td>\n            </tr>\n        ";
;
}
}
frame = frame.pop();
output += "\n    </tbody>\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "apiMessage")) {
output += "\n    <span>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "apiMessage"), env.opts.autoescape);
output += "</span>\n";
;
}
else {
output += "\n    <span>No results</span>\n\n";
;
}
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/admin/templates/includes/_products_search_results", function(){});

